document.addEventListener("DOMContentLoaded", () => {
    const items = document.querySelectorAll(".top-menu-item");

    items.forEach(item => {
        item.addEventListener("click", () => {
            const childUl = item.querySelector(":scope > ul");

            if (item.classList.contains("is-active")) {
                // If already active → remove classes
                item.classList.remove("is-active");
                if (childUl) {
                childUl.classList.remove("js-dropdown-active");
                }
            } else {
                // If not active → add classes
                item.classList.add("is-active");
                if (childUl) {
                childUl.classList.add("js-dropdown-active");
                }
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", () => {
  const menus = document.querySelectorAll(".top-menu-item > .menu");
  let activeMenu = null;

  // Helpers to lock/unlock body scroll
  function lockBodyScroll() {
    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";
    document.body.dataset.scrollY = scrollY; // remember position
  }

  function unlockBodyScroll() {
    const scrollY = parseInt(document.body.dataset.scrollY || "0", 10);
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    window.scrollTo(0, scrollY);
    delete document.body.dataset.scrollY;
  }

  function applyHeight(menu) {
    const maxAllowed = window.innerHeight - 150;
    const fullHeight = menu.scrollHeight;

    if (fullHeight > maxAllowed) {
      menu.style.height = maxAllowed + "px";
      menu.style.overflowY = "auto";
    } else {
      menu.style.height = fullHeight + "px";
      menu.style.removeProperty("overflow-y");
    }
    activeMenu = menu;
  }

  function anyMenuOpen() {
    return Array.from(menus).some(m => m.classList.contains("js-dropdown-active"));
  }

  menus.forEach(menu => {
    const observer = new MutationObserver(() => {
      if (menu.classList.contains("js-dropdown-active")) {
        // Close all other menus
        menus.forEach(other => {
          if (other !== menu) {
            other.classList.remove("js-dropdown-active");
          }
        });

        // Animate opening
        menu.style.transition = "height 200ms ease";
        menu.style.height = "0px";
        menu.getBoundingClientRect();

        setTimeout(() => {
          applyHeight(menu);
          lockBodyScroll();

          const onEnd = (e) => {
            if (e.propertyName !== "height") return;
            menu.removeEventListener("transitionend", onEnd);
            menu.style.removeProperty("transition");
          };
          menu.addEventListener("transitionend", onEnd);
        }, 100);
      } else {
        // Close instantly
        menu.style.transition = "none";
        menu.style.removeProperty("height");
        menu.style.removeProperty("overflow-y");
        requestAnimationFrame(() => {
          menu.style.removeProperty("transition");
        });

        // Unlock page scroll if none open
        if (!anyMenuOpen()) {
          unlockBodyScroll();
        }

        if (activeMenu === menu) activeMenu = null;
      }
    });

    observer.observe(menu, { attributes: true, attributeFilter: ["class"] });
  });

  // Recalculate height on resize for the active menu
  window.addEventListener("resize", () => {
    if (activeMenu && activeMenu.classList.contains("js-dropdown-active")) {
      applyHeight(activeMenu);
    }
  });
});

(function () {
  var nav = document.getElementById('offcanvas-nav');
  if (!nav) return;

  function getSubmenu(li) {
    return li.querySelector(':scope > ul.vertical.menu');
  }

  function expand(li) {
    var submenu = getSubmenu(li);
    if (!submenu) return;

    // If already auto, do nothing
    if (li.classList.contains('is-open') && submenu.style.height === 'auto') return;

    // Fix current height, then animate to scrollHeight
    var start = submenu.offsetHeight; // reflow
    submenu.style.height = start + 'px';
    requestAnimationFrame(function () {
      submenu.style.transition = 'height 350ms ease';
      submenu.style.height = submenu.scrollHeight + 'px';
    });

    li.classList.add('is-open');
    li.setAttribute('aria-expanded', 'true');

    var onEnd = function (e) {
      if (e.propertyName !== 'height') return;
      submenu.style.transition = '';
      submenu.style.height = 'auto';
      submenu.removeEventListener('transitionend', onEnd);
    };
    submenu.addEventListener('transitionend', onEnd);
  }

  function collapse(li) {
    var submenu = getSubmenu(li);
    if (!submenu) return;

    // From auto -> fixed -> 0
    var current = submenu.scrollHeight;
    submenu.style.height = current + 'px';
    submenu.offsetHeight; // reflow
    requestAnimationFrame(function () {
      submenu.style.transition = 'height 350ms ease';
      submenu.style.height = '0px';
    });

    li.classList.remove('is-open');
    li.setAttribute('aria-expanded', 'false');

    var onEnd = function (e) {
      if (e.propertyName !== 'height') return;
      submenu.style.transition = '';
      // keep at 0; no auto after collapsing
      submenu.removeEventListener('transitionend', onEnd);
    };
    submenu.addEventListener('transitionend', onEnd);
  }

  function toggle(li) {
    if (!li.classList.contains('menu-item-has-children')) return;

    // Single-expand per level: only close siblings that also have children
    var parentUl = li.parentElement;
    if (parentUl) {
      var openSiblings = parentUl.querySelectorAll(':scope > li.menu-item-has-children.is-open');
      for (var i = 0; i < openSiblings.length; i++) {
        var sib = openSiblings[i];
        if (sib !== li) collapse(sib);
      }
    }

    if (li.classList.contains('is-open')) collapse(li);
    else expand(li);
  }

  // CSS baseline via JS (optional if you already have CSS)
  (function initBaseline() {
    var items = nav.querySelectorAll('li.menu-item-has-children');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      li.setAttribute('aria-expanded', 'false');
      var submenu = getSubmenu(li);
      if (submenu) {
        submenu.style.overflow = 'hidden';
        submenu.style.height = '0px';
      }
    }
  })();

  // Clicks:
  // - If you clicked an <a>, let it navigate (do nothing)
  // - Otherwise, if you clicked inside a LI.menu-item-has-children, toggle it
  nav.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (link && nav.contains(link)) return;

    var li = e.target.closest('li.menu-item-has-children');
    if (!li || !nav.contains(li)) return;

    e.preventDefault();
    toggle(li);
  });

  // Optional keyboard support (without hijacking link keys)
  nav.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (e.target.closest('a')) return;
    var li = e.target.closest('li.menu-item-has-children');
    if (!li || !nav.contains(li)) return;
    e.preventDefault();
    toggle(li);
  });

  // Auto-open the current path (WordPress active classes)
  (function openCurrentPath() {
    var sel = [
      'li.current-menu-ancestor',
      'li.current-menu-item',
      'li.current_page_ancestor',
      'li.current_page_item'
    ].join(',');
    var actives = nav.querySelectorAll(sel);
    for (var i = 0; i < actives.length; i++) {
      var cursor = actives[i];
      // Walk up, expanding only .menu-item-has-children
      while (cursor && cursor.matches && cursor.matches('li.menu-item-has-children')) {
        expand(cursor);
        cursor = cursor.parentElement ? cursor.parentElement.closest('li.menu-item-has-children') : null;
      }
    }
  })();
})();